import HelpPage from '../src/pages/HelpPage';
export default HelpPage;
